import { PlatformCard, Step } from '../../models/platform';

import { useQuery } from "@tanstack/react-query";
import { useRestClient } from "../../api/RestClientContext";
import { LinkInfo } from '../../models/link';
import { renderStep } from "../../pages/setup/renderSteps";

export function usePlatformsInstruction(link?: LinkInfo) {
    const client = useRestClient();

    const query = useQuery({
        queryKey: ['platforms', link?.link],
        queryFn: async () => {
            const data = await client.getPlatforms();
            
            if (!data.success) throw new Error(data.message ?? 'Ошибка загрузки');

            // Маппим DTO -> компоненты
            return data.result.map((platform: PlatformCard) => ({
                id: platform.id,
                platform: platform.platform,
                iconName: platform.iconName,
                match: platform.match,
                providers: platform.providers.map((provider) => ({
                    appName: provider.appName,
                    videoInstruction: provider.videoInstruction,
                    steps: provider.steps.map((step: Step) => renderStep(step, link?.link)),
                })),
            }));
        },
        enabled: !!link,
        refetchOnWindowFocus: false,
        retry: false,
    });

    return {
        platforms: query.data ?? [],
        loading: query.isLoading,
        error: query.error,
    };
}